import { render, staticRenderFns } from "./SparringRoundScore.vue?vue&type=template&id=b0898b1e&scoped=true"
import script from "./SparringRoundScore.vue?vue&type=script&lang=js"
export * from "./SparringRoundScore.vue?vue&type=script&lang=js"
import style0 from "./SparringRoundScore.vue?vue&type=style&index=0&id=b0898b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0898b1e",
  null
  
)

export default component.exports